import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;
const base = `${API_URL}/api/trade-shows`;
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });

const listTradeShows  = ()         => axios.get(base, auth()).then(r => r.data.tradeShows);
const getTradeShow    = (id)       => axios.get(`${base}/${id}`, auth()).then(r => r.data.tradeShow);
const createTradeShow = (data)     => axios.post(base, data, auth()).then(r => r.data.tradeShow);
const updateTradeShow = (id, data) => axios.put(`${base}/${id}`, data, auth()).then(r => r.data.tradeShow);
const deleteTradeShow = (id)       => axios.delete(`${base}/${id}`, auth()).then(r => r.data);
const getYearSummary  = (year)     => axios.get(`${base}/summary`, { ...auth(), params: { year } }).then(r => r.data);
const getPnl          = (id)       => axios.get(`${base}/${id}/pnl`, auth()).then(r => r.data.pnl);
const getQrCode       = (id)       => axios.get(`${base}/${id}/qr-code`, auth()).then(r => r.data);
const regenerateToken = (id)       => axios.post(`${base}/${id}/regenerate-token`, {}, auth()).then(r => r.data);

const listExpenses  = (id)         => axios.get(`${base}/${id}/expenses`, auth()).then(r => r.data.expenses);
const addExpense    = (id, data)   => axios.post(`${base}/${id}/expenses`, data, auth()).then(r => r.data.expense);
const updateExpense = (expenseId, data) => axios.put(`${base}/expenses/${expenseId}`, data, auth()).then(r => r.data.expense);
const deleteExpense = (expenseId)  => axios.delete(`${base}/expenses/${expenseId}`, auth()).then(r => r.data);

const listLeads   = (id)       => axios.get(`${base}/${id}/leads`, auth()).then(r => r.data.leads);
// Small JSON payload — a generous but bounded timeout so a stalled mobile connection fails
// visibly (with a retry path) instead of leaving the Save button stuck spinning forever.
const addLead     = (id, data) => axios.post(`${base}/${id}/leads`, data, { ...auth(), timeout: 20000 }).then(r => r.data.lead);
const updateLead  = (leadId, data) => axios.put(`${base}/leads/${leadId}`, data, auth()).then(r => r.data.lead);
const deleteLead  = (leadId)   => axios.delete(`${base}/leads/${leadId}`, auth()).then(r => r.data);
const scanCard    = (id, imageBase64, mediaType) => axios.post(`${base}/${id}/leads/scan-card`, { imageBase64, mediaType }, auth()).then(r => r.data);
const convertLead = (leadId, data) => axios.post(`${base}/leads/${leadId}/convert`, data, auth()).then(r => r.data);
// CSV export needs the auth header, so it's fetched as a blob rather than a plain <a href> link.
const exportLeads = (id) => axios.get(`${base}/${id}/leads/export`, { ...auth(), responseType: 'blob' }).then(r => r.data);

// CSV import — AI column-mapping preview, then a deterministic confirm. Generous timeout since
// the preview call makes a real AI request.
const previewLeadImport = (id, csvText) =>
  axios.post(`${base}/${id}/leads/import/preview`, { csvText }, { ...auth(), timeout: 30000 }).then(r => r.data);
const confirmLeadImport = (id, csvText, mapping) =>
  axios.post(`${base}/${id}/leads/import`, { csvText, mapping }, { ...auth(), timeout: 30000 }).then(r => r.data);

const generateFollowUpEmail = (id, highlights) => axios.post(`${base}/${id}/generate-followup-email`, { highlights }, auth()).then(r => r.data.tradeShow);
const saveFollowUpEmail     = (id, data) => axios.put(`${base}/${id}/followup-email`, data, auth()).then(r => r.data.tradeShow);

// Public, no-auth self-serve capture
const getPublicTradeShow = (token) => axios.get(`${base}/public/${token}`).then(r => r.data.tradeShow);
const submitPublicLead   = (token, data) => axios.post(`${base}/public/${token}/leads`, data).then(r => r.data);

const tradeShowService = {
  listTradeShows, getTradeShow, createTradeShow, updateTradeShow, deleteTradeShow,
  getYearSummary, getPnl, getQrCode, regenerateToken,
  listExpenses, addExpense, updateExpense, deleteExpense,
  listLeads, addLead, updateLead, deleteLead, scanCard, convertLead, exportLeads,
  previewLeadImport, confirmLeadImport,
  generateFollowUpEmail, saveFollowUpEmail,
  getPublicTradeShow, submitPublicLead,
};
export default tradeShowService;
